export default {
  common: {
    save: 'Guardar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    delete: 'Eliminar',
    edit: 'Editar',
    view: 'Ver',
    back: 'Volver',
    close: 'Cerrar',
    add: 'Agregar',
    send: 'Enviar',
    sending: 'Enviando...',
    saving: 'Guardando...',
    loading: 'Cargando...',
    search: 'Buscar',
    update: 'Actualizar',
    create: 'Crear',
    creating: 'Creando...',
    transfer: 'Transferir',
    approve: 'Aprobar',
    reject: 'Rechazar',
    ok: 'Entendido',
    name: 'Nombre',
    username: 'Usuario',
    password: 'Contraseña',
    email: 'Correo electrónico',
    date: 'Fecha',
    status: 'Estado',
    type: 'Tipo',
    quantity: 'Cantidad',
    description: 'Descripción',
    project: 'Proyecto',
    task: 'Tarea',
    logout: 'Cerrar sesión',
    notifications: 'Notificaciones',
    settings: 'Configuraciones',
    draft: 'Borrador',
    sent: 'Enviado',
    active: 'Activo',
    inactive: 'Inactivo',
    priority: 'Prioridad',
    language: 'Idioma',
    yes: 'Sí',
    no: 'No',
    error: 'Error',
    success: 'Éxito',
    warning: 'Atención',
    required: 'Obligatorio',
    optional: 'Opcional',
    all: 'Todos',
    none: 'Ninguno',
    upload: 'Subir archivo',
    download: 'Descargar',
    print: 'Imprimir',
    actions: 'Acciones',
    details: 'Detalles',
    filters: 'Filtros',
    results: 'Resultados',
    noResults: 'No se encontraron resultados',
    total: 'Total',
    of: 'de',
    verified: 'verificado',
    pending: 'Pendiente',
    completed: 'Completado',
    cancelled: 'Cancelado',
  },

  auth: {
    login: 'Iniciar sesión',
    loginTitle: 'Inicia sesión en tu cuenta',
    logout: 'Cerrar sesión',
    register: 'Registrarse',
    forgotPassword: '¿Olvidaste tu contraseña?',
    resetPassword: 'Restablecer contraseña',
    usernameOrEmail: 'Usuario o correo electrónico',
    enterPassword: 'Ingresa tu contraseña',
    enterUsername: 'Ingresa tu usuario',
    loginError: 'Usuario o contraseña incorrectos.',
    sessionExpired: 'Sesión expirada. Inicia sesión nuevamente.',
  },

  nav: {
    dashboard: 'Panel de control',
    overview: 'Visión general',
    documents: 'Documentos',
    viewDocuments: 'Ver documentos',
    manageProjects: 'Gestionar proyectos',
    viewProjects: 'Ver proyectos',
    manageUsers: 'Gestionar usuarios',
    viewUsers: 'Ver usuarios',
    manageWarehouse: 'Gestionar Almacén',
    viewWarehouse: 'Ver Almacén',
    manageMachinery: 'Gestionar Maquinaria',
    viewMachinery: 'Ver Maquinaria',
    manageSystem: 'Configuración del sistema',
    projects: 'Proyectos',
    myProjects: 'Mis proyectos',
    myTasks: 'Mis tareas',
    reports: 'Informes',
    drawings: 'Planos',
    warehouse: 'Almacén',
    checkStock: 'Consultar stock',
    requests: 'Solicitudes',
    requestItem: 'Solicitar ítem',
    tickets: 'Tickets',
    messages: 'Mensajes',
    adminMode: 'Modo administrador',
    standardMode: 'Modo estándar',
    analystMode: 'Modo analista',
    createReport: 'Crear informe',
    createReports: 'Informes de obra',
    dailyReport: 'Informe diario de obra',
    incidentReport: 'Informe de incidente',
    safetySection: 'Seguridad laboral',
    safetyDialog: 'Diálogos de seguridad',
    workPermit: 'Permiso de trabajo crítico',
    occurrenceReport: 'Informe de ocurrencia',
    settingsMenu: 'Configuraciones',
  },

  profile: {
    editProfile: 'Editar perfil',
    displayName: 'Nombre',
    usernameLabel: 'Nombre de usuario',
    passwordLabel: 'Contraseña',
    changePassword: 'Cambiar contraseña',
    appearance: 'Apariencia',
    lightMode: 'Modo claro',
    darkMode: 'Modo oscuro',
    languageLabel: 'Idioma',
    cropTitle: 'Recortar foto de perfil',
    cropUse: 'Usar esta área',
    zoom: 'Zoom',
    currentPassword: 'Confirmar contraseña actual',
    newPassword: 'Nueva contraseña',
    confirmNewPassword: 'Confirmar nueva contraseña',
    emailVerified: 'verificado',
    emailChange: 'Cambiar',
    emailSendCode: 'Enviar código',
    emailConfirm: 'Confirmar',
    emailResend: '← Reenviar código',
    emailCancelChange: 'Cancelar',
    emailSending: 'Enviando...',
    emailVerifying: 'Verificando...',
    emailHint: 'Código enviado a {email}. Revisa tu bandeja y spam.',
    emailSuccess: 'Correo {email} verificado exitosamente.',
    emailInvalidError: 'Ingresa un correo electrónico válido.',
    emailGenericError: 'Error al enviar el código.',
    emailInvalidCode: 'Código inválido.',
    passwordFillAll: 'Completa todos los campos de contraseña.',
    passwordWrong: 'La contraseña actual es incorrecta.',
    passwordMismatch: 'La confirmación de la nueva contraseña no coincide.',
    saveFillAll: 'Completa nombre y usuario.',
    saveFinishPassword: 'Finaliza o cancela el cambio de contraseña antes de guardar.',
    avatarAlt: 'perfil',
  },

  dashboard: {
    overview: 'Visión general',
    myProjects: 'Mis proyectos',
    myTasks: 'Mis tareas',
    activeProjects: 'Proyectos activos',
    completedTasks: 'Tareas completadas',
    pendingTasks: 'Tareas pendientes',
    recentActivity: 'Actividad reciente',
    noProjects: 'No se encontraron proyectos.',
    noTasks: 'No se encontraron tareas.',
    createProject: 'Crear proyecto',
    projectName: 'Nombre del proyecto',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de fin',
  },

  projects: {
    title: 'Proyectos',
    newProject: 'Nuevo proyecto',
    projectName: 'Nombre del proyecto',
    startDate: 'Inicio',
    endDate: 'Fin',
    progress: 'Progreso',
    team: 'Equipo',
    gantt: 'Planificación',
    files: 'Archivos',
    tickets: 'Tickets',
    warehouse: 'Almacén',
    dds: 'Charla de seguridad',
    reports: 'Informes',
    noProjects: 'Sin proyectos.',
    deleteConfirm: '¿Seguro que deseas eliminar este proyecto?',
  },

  tasks: {
    title: 'Tareas',
    newTask: 'Nueva tarea',
    taskName: 'Nombre de la tarea',
    assignee: 'Responsable',
    dependencies: 'Dependencias',
    duration: 'Duración (días)',
    startDate: 'Inicio',
    endDate: 'Fin',
    progress: 'Progreso',
    addProgress: 'Registrar progreso',
    noTasks: 'Sin tareas.',
    blocked: 'Bloqueada',
    inProgress: 'En progreso',
    done: 'Completada',
    deleteConfirm: '¿Eliminar esta tarea?',
  },

  warehouse: {
    title: 'Almacén',
    stock: 'Stock',
    requestItem: 'Solicitar ítem',
    requests: 'Solicitudes',
    addItem: 'Agregar ítem',
    itemName: 'Nombre del ítem',
    category: 'Categoría',
    unit: 'Unidad',
    available: 'Disponible',
    reserved: 'Reservado',
    transferItem: 'Transferir ítem',
    reportDamage: 'Reportar daño',
    provideEquipment: 'Proveer equipamiento',
    noItems: 'No hay ítems en stock.',
    noRequests: 'Sin solicitudes.',
    approveRequest: 'Aprobar solicitud',
    rejectRequest: 'Rechazar solicitud',
    requestStatus: {
      pending: 'Pendiente',
      approved: 'Aprobado',
      rejected: 'Rechazado',
      delivered: 'Entregado',
    },
  },

  safety: {
    title: 'Seguridad',
    dds: 'Charla de seguridad',
    ddsTitle: 'Diálogo Diario de Seguridad',
    newDds: 'Nueva charla',
    occurrences: 'Ocurrencias',
    permits: 'Permisos',
    createDialog: 'Crear diálogo',
    createOccurrence: 'Registrar ocurrencia',
    createPermit: 'Crear permiso',
    topic: 'Tema',
    presenter: 'Presentador',
    attendees: 'Participantes',
    date: 'Fecha',
    noSafety: 'Sin registros de seguridad.',
  },

  tickets: {
    title: 'Tickets',
    newTicket: 'Nuevo ticket',
    subject: 'Asunto',
    category: 'Categoría',
    openedBy: 'Abierto por',
    assignedTo: 'Asignado a',
    openTickets: 'Tickets abiertos',
    closedTickets: 'Tickets cerrados',
    noTickets: 'Sin tickets.',
    status: {
      open: 'Abierto',
      inProgress: 'En progreso',
      closed: 'Cerrado',
    },
  },

  users: {
    title: 'Usuarios',
    newUser: 'Nuevo usuario',
    role: 'Rol',
    roles: {
      adminMaster: 'Admin Master',
      adminObra: 'Admin Obra',
      user: 'Usuario',
    },
    noUsers: 'Sin usuarios.',
    deleteConfirm: '¿Eliminar este usuario?',
    manageRoles: 'Gestionar roles',
    manageUsers: 'Gestión de usuarios',
    userList: 'Lista de usuarios',
  },

  system: {
    title: 'Configuración del sistema',
    siteName: 'Nombre del sistema',
    logo: 'Logo',
    loginBackground: 'Fondo del login',
    primaryColor: 'Color primario',
    save: 'Guardar configuración',
    saved: 'Configuración guardada.',
  },

  reports: {
    title: 'Informes',
    daily: 'Informe diario',
    incident: 'Informe de incidente',
    noReports: 'Sin informes.',
    createReport: 'Crear informe',
    date: 'Fecha',
    author: 'Autor',
    content: 'Contenido',
  },

  machinery: {
    title: 'Maquinaria Pesada',
    newMachine: 'Nuevo equipo',
    machineName: 'Nombre',
    model: 'Modelo',
    plate: 'Placa',
    status: 'Estado',
    noMachinery: 'Sin equipos.',
  },

  messenger: {
    title: 'Mensajes',
    newMessage: 'Nuevo mensaje',
    noMessages: 'Sin mensajes.',
    typeMessage: 'Escribe un mensaje...',
    send: 'Enviar',
  },
}
